import { InjectionToken } from "@angular/core";
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { ENVIRONMENT } from "../environments/environment";

// export const MSAL_INSTANCE_REAL = new InjectionToken<PublicClientApplication>("MSAL_INSTANCE");
export const MSAL_GUARD_CONFIG = new InjectionToken<MsalGuardConfiguration>("MSAL_GUARD_CONFIG");
export const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const MSAL_INSTANCE_REAL: PublicClientApplication = new PublicClientApplication({
  auth: {
    clientId: ENVIRONMENT.MSAL.clientId,
    authority: `https://login.microsoftonline.com/${ENVIRONMENT.MSAL.tenantId}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false,
  },
});

export function msalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ENVIRONMENT.MSAL.scopes,
    },
    loginFailedRoute: "/login-failed",
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set("https://graph.microsoft.com/v1.0/", ["user.read", "Directory.Read.All"]);
  protectedResourceMap.set("http://localhost:8080/v1/", ["user.read", "Directory.Read.All"]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
